import { Button, FormControl, FormLabel, Stack, ToggleButtonGroup, Typography } from '@healthinal/ui';
import { useAtom } from 'jotai';
import { useState } from 'react';
import { GermanDateInput } from '../../../components/form/GermanDateInput.tsx';
import { HistoryFilter, historyFilterAtom, historyRangeFilterAtom } from '../../../state/historySearchAtoms.ts';
import { getHistoryFilterName } from '../../../utils/historySearch/historyFilter.ts';

export function HistoryHeaderFilter() {
  const [historyFilter, setHistoryFilter] = useAtom(historyFilterAtom);
  const [range, setRange] = useAtom(historyRangeFilterAtom);

  const [tempRange, setTempRange] = useState(range);

  const handleBlur = () => {
    setRange(tempRange);
  };

  return (
    <Stack gap={4} direction={'row'} alignItems={'end'}>
      <ToggleButtonGroup value={historyFilter}>
        {Object.values(HistoryFilter).map((filter) => (
          <Button key={filter} value={filter} onClick={() => setHistoryFilter(filter)}>
            {getHistoryFilterName(filter)}
          </Button>
        ))}
      </ToggleButtonGroup>
      <Stack direction={'row'} gap={2}>
        <FormControl>
          <FormLabel>
            <Typography>Von</Typography>
          </FormLabel>
          <GermanDateInput
            value={tempRange.from}
            onChange={(value) => setTempRange((prev) => ({ from: value, until: prev.until }))}
            onValueBlur={handleBlur}
          />
        </FormControl>
        <FormControl>
          <FormLabel>
            <Typography>Bis</Typography>
          </FormLabel>
          <GermanDateInput
            value={tempRange.until}
            onChange={(value) => setTempRange((prev) => ({ from: prev.from, until: value }))}
            onValueBlur={handleBlur}
          />
        </FormControl>
      </Stack>
    </Stack>
  );
}
